import React from 'react';
import ColumnMapper, { OptionInfo, TargetField } from '#/common/components/ColumnMapper';
import { StyledNuvoBox } from '#/common/styles/template';
import { NuvoLabel } from '@nuvolo/nuux-core/components/NuvoLabel';
import { useViewport } from '@nuvolo/nuux-theme/hooks/useViewport';

// Define the non-mandatory fields
const additionalFields = [
  { key: 'location_path', label: 'Location' },
  { key: 'install_date', label: 'Install Date' },
  { key: 'condition', label: 'Condition' },
  { key: 'acquisition_cost_value', label: 'Acquisition Cost' },
  { key: 'maintenance_cost_value', label: 'Maintenance Cost' },
  { key: 'useful_life', label: 'Useful Life (In Years)' },
] as TargetField[];

export interface MapAdditionalFieldsStepProps {
  csvColumns: OptionInfo[];
  mapping: Record<string, string>;
  setMapping: React.Dispatch<React.SetStateAction<Record<string, string>>>;
}

const MapAdditionalFieldsStep: React.FC<MapAdditionalFieldsStepProps> = ({
  csvColumns,
  mapping,
  setMapping,
}) => {
  const { isDesktop } = useViewport();

  return (
    <StyledNuvoBox isDesktop={isDesktop}>
      <div className="box-caption">
        <NuvoLabel>Match Additional Columns</NuvoLabel>
      </div>

      <ColumnMapper
        sourceOptions={csvColumns}
        targetFields={additionalFields}
        mapping={mapping}
        setMapping={setMapping}
        sourceLabel="Your File Columns"
        targetLabel="TMM Columns"
      />
    </StyledNuvoBox>
  );
};

export default React.memo(MapAdditionalFieldsStep);
